import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { BiData } from '@wix/da-bi/pkg/events';
import NativeDropdown from '../../../../Dropdown/NativeDropdown';
import { useRestrictToLoggedIn } from '../../../../utils/hooks/useRestrictToLoggedIn';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import { useDeviationAttributes } from '../../../../DeviationViews/hooks/useDeviationAttributes';
import s from './MoreMenuMobileDropdown.scss';
const MoreMenuMobileDropdown = ({ deviation , isOwner , showReportModal , showMobileDeviationSharePopup , showNftLinkPopup , showAddToGroupPopup , shareDeviationToPost  })=>{
    const { t  } = useTranslation();
    const isAddToGroupInDropdownFlagEnabled = useFlag('add_to_group_in_dropdown');
    const { isLoggedIn , sendUserToJoinPage  } = useRestrictToLoggedIn();
    const { isShareable , isReportable , hasNft , isGroupSubmittable  } = useDeviationAttributes(deviation, isOwner);
    const onSelect = (value)=>{
        switch(value){
            case 'addtogroup':
                showAddToGroupPopup(deviation);
                break;
            case 'share':
                showMobileDeviationSharePopup(deviation);
                break;
            case 'sharetopost':
                isLoggedIn ? shareDeviationToPost(deviation) : sendUserToJoinPage(ReferralType.SHARE_TO_POST);
                break;
            case 'report':
                showReportModal(deviation);
                break;
            case 'linknft':
                showNftLinkPopup(deviation);
                break;
            default:
        }
    };
    return /*#__PURE__*/ React.createElement(NativeDropdown, {
        className: s['root'],
        onSelect: onSelect,
        openBiData: {
            evid: BiEventType.MORE_MENU_CLICK,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
            sectionname: 'deviation'
        },
        items: [
            isAddToGroupInDropdownFlagEnabled && !isOwner && isGroupSubmittable && {
                value: 'addtogroup',
                label: t('actionbar.addToGroup'),
                biData: BiData({
                    evid: 340,
                    deviationid: deviation.deviationId,
                    sectionname: 'add_to_group'
                })
            },
            isShareable && {
                value: 'share',
                label: t('actionbar.share'),
                biData: BiData({
                    evid: 355,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                    deviationid: deviation.deviationId
                })
            },
            isShareable && {
                value: 'sharetopost',
                label: t('actionbar.shareToPost'),
                biData: BiData({
                    evid: 356,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                    social_share: 'da_post',
                    deviationid: deviation.deviationId
                })
            },
            isReportable && {
                value: 'report',
                label: t('actionbar.report'),
                biData: BiData({
                    evid: 20,
                    modal_version: 2,
                    deviationid: deviation.deviationId
                })
            },
            !hasNft && isOwner && {
                value: 'linknft',
                label: t('actionbar.linkNft')
            }
        ]
    });
};
MoreMenuMobileDropdown.displayName = 'MoreMenuMobileDropdown';
export default MoreMenuMobileDropdown;
